if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        // Event delegation: catches clicks on prev/next nav buttons reliably
        this.addEventListener('click', (event) => {
          const prevBtn = event.target.closest('.product-media-modal__nav--prev');
          const nextBtn = event.target.closest('.product-media-modal__nav--next');

          if (prevBtn) {
            event.preventDefault();
            event.stopPropagation();
            this.navigate(-1);
          } else if (nextBtn) {
            event.preventDefault();
            event.stopPropagation();
            this.navigate(1);
          }
        });

        // Keyboard arrow navigation (Left / Right)
        this.addEventListener('keyup', (event) => {
          if (event.code === 'ArrowLeft') this.navigate(-1);
          if (event.code === 'ArrowRight') this.navigate(1);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      navigate(direction) {
        const allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        if (!allMedia.length) return;

        let activeIndex = allMedia.findIndex((el) => el.classList.contains('active'));
        if (activeIndex === -1) activeIndex = 0;

        allMedia[activeIndex].classList.remove('active');

        let newIndex = activeIndex + direction;
        if (newIndex < 0) newIndex = allMedia.length - 1;
        if (newIndex >= allMedia.length) newIndex = 0;

        const targetMedia = allMedia[newIndex];
        targetMedia.classList.add('active');

        // Update counter number (1-indexed)
        const counterCurrent = this.querySelector('.product-media-modal__counter-current');
        if (counterCurrent) counterCurrent.textContent = newIndex + 1;
      }

      showActiveMedia() {
        const allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        const targetId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
        let activeIndex = 0;

        allMedia.forEach((element, idx) => {
          if (targetId && element.getAttribute('data-media-id') === targetId) {
            element.classList.add('active');
            activeIndex = idx;
          } else if (!targetId && idx === 0) {
            element.classList.add('active');
            activeIndex = 0;
          } else {
            element.classList.remove('active');
          }
        });

        const counterCurrent = this.querySelector('.product-media-modal__counter-current');
        if (counterCurrent) counterCurrent.textContent = activeIndex + 1;
      }
    }
  );
}
